import { useTranslation } from 'react-i18next';
import useStyles from './styles';

const DemoIndicator = () => {
    const classes = useStyles();
    const [t] = useTranslation();
    const demoTitle = 'DEMO_DATA.DEMO_TITLE_LABEL';
    return <div className={classes.demoTitle}>{t(demoTitle)}</div>;
};

export default DemoIndicator;
